import * as type from '../actions/types';

const initialState = {
  eventsImpact: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_EVENTS_IMPACT_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.FETCH_EVENTS_IMPACT_SUCCESS:
      return {
        ...state,
        eventsImpact: action.payload,
        loading: false,
        error: null,
      };

    case type.FETCH_EVENTS_IMPACT_FAILURE:
      return {
        ...state,
        eventsImpact: null,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
